import {
  ACTION_TYPE,
  CREATE,
  CREATE_TYPE,
} from '@/constants/semanticNames'

const INSTALLATION_CREATE_MODE_KEYS = [
  ACTION_TYPE,
  CREATE_TYPE,
  CREATE,
  'createMode',
  'editMode',
]

/**
 * Params for viewing a node after create/edit — without create/edit mode flags.
 */
export const buildInstallationViewParams = (params = {}) => {
  const viewParams = { ...params }

  INSTALLATION_CREATE_MODE_KEYS.forEach((key) => {
    delete viewParams[key]
  })

  return viewParams
}
